import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-custom__header" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_5 = { class: "p-field mr-3" }
const _hoisted_6 = { class: "p-field-label mb-3" }
const _hoisted_7 = { class: "calling-code-container" }
const _hoisted_8 = { class: "calling-code-card" }
const _hoisted_9 = { class: "column-code" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "vertical-line" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "code" }, "B", -1)
const _hoisted_12 = { class: "column-code" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "vertical-line" }, null, -1)
const _hoisted_14 = { class: "code" }
const _hoisted_15 = { class: "column-code" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "vertical-line" }, null, -1)
const _hoisted_17 = { class: "code" }
const _hoisted_18 = { class: "column-code" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "vertical-line" }, null, -1)
const _hoisted_20 = { class: "code" }
const _hoisted_21 = { class: "text-center mt-4" }
const _hoisted_22 = /*#__PURE__*/_createVNode("b", null, "Example:", -1)
const _hoisted_23 = { class: "code" }
const _hoisted_24 = { class: "code" }
const _hoisted_25 = { class: "code" }
const _hoisted_26 = { class: "code" }
const _hoisted_27 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("AppResourceEP.SetupWizardStepSummaryTitle")), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_ElScrollbar, null, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("AppResourceEP.SetupWizardStepSummarySubTitle")), 1)
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.Building")), 1),
                  _hoisted_10,
                  _hoisted_11
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.Riser")), 1),
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.RiserShort")), 1),
                    _createVNode("span", {
                      class: {
                                        gray: !_ctx.recapCode.riserDoubleChars,
                                    }
                    }, _toDisplayString(_ctx.$t("AppResourceEP.RiserShort")), 3)
                  ])
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.Floor")), 1),
                  _hoisted_16,
                  _createVNode("div", _hoisted_17, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.FloorShort")), 1),
                    _createVNode("span", {
                      class: {
                                        gray: !_ctx.recapCode.floorDoubleChars,
                                    }
                    }, _toDisplayString(_ctx.$t("AppResourceEP.FloorShort")), 3)
                  ])
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.Apartment")), 1),
                  _hoisted_19,
                  _createVNode("div", _hoisted_20, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.ApartmentShort")), 1),
                    _createVNode("span", {
                      class: {
                                        gray: !_ctx.recapCode.apartmentDoubleChars,
                                    }
                    }, _toDisplayString(_ctx.$t("AppResourceEP.ApartmentShort")), 3)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode("div", null, [
                  _createVNode("span", _hoisted_23, _toDisplayString(_ctx.recapCode.buildingCode), 1),
                  _createVNode("span", _hoisted_24, _toDisplayString(_ctx.recapCode.riserCode), 1),
                  _createVNode("span", _hoisted_25, _toDisplayString(_ctx.recapCode.floorCode), 1),
                  _createVNode("span", _hoisted_26, _toDisplayString(_ctx.recapCode.apartmentCode), 1)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("footer", _hoisted_27, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleBackButton,
        label: _ctx.$t('AppResource.Back'),
        class: "p-button-text mr-3"
      }, null, 8, ["onClick", "label"]),
      _createVNode(_component_Button, {
        onClick: _ctx.handleNextButton,
        label: _ctx.$t('AppResource.Continue'),
        class: "p-button-rounded p-button-raised p-button--m"
      }, null, 8, ["onClick", "label"])
    ])
  ], 64))
}